export default "__VITE_ASSET__91d469d5__"